import React, { Component } from "react";
import { RichText } from "prismic-reactjs";
import { linkResolver } from "../prismic-configuration";

export class YearOfActionResource extends Component {
  render() {
    const { item } = this.props;

    return (
      <div className="row mb-4">
        <div className="col-3">
          <img src={item.data.main_image.url} alt="" className="img-fluid" />
        </div>

        <div className="col-9">
          <p>
            <a href={linkResolver(item)} className="text-orange">
              <strong>{RichText.asText(item.data.title)}</strong>
            </a>
          </p>
          {item.data.excerpt.length !== 0 && (
            <p>{RichText.asText(item.data.excerpt, linkResolver)}</p>
          )}
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/YearOfActionResource.js